import React from 'react';
import PropTypes from "prop-types";
import {Checkbox, Icon} from "semantic-ui-react";
import _ from "lodash";
import {connect} from "react-redux";
import {
    openEditKYBTestcacheRecordsModal,
    selectSomeKYBTestcache,
    toggleDeleteKYBTestcacheRecordsModal
} from "../actions/KYBTestCacheActions";


const COUNTRIES = require("../../common/resources/countries.json");

export class KYBTestCacheListRow extends React.Component {

    // React's built-in state targeted to toggle the add-edit buttons on hover
    state = {
        isHovered: false,
    }

    static propTypes = {
        kybTestcacheRecord: PropTypes.object,
        organizationName: PropTypes.string,
        businessId: PropTypes.string,
        businessIdType: PropTypes.string,
        addressLine1: PropTypes.string,
        locality: PropTypes.string,
        province: PropTypes.string,
        postalcode: PropTypes.string,
        countryCode: PropTypes.string,
        phoneNumber: PropTypes.string,
        emailAddress: PropTypes.string,
        domain: PropTypes.string,
        datasource: PropTypes.string,
        id: PropTypes.number,
        isSelected: PropTypes.bool,
    }

    handleKYBTestcacheCheckboxSelect = (e, {checked}) => {
        this.props.selectSomeKYBTestcache(this.props.id, checked);
    }

    handleEditKYBTestcacheRecord = () => {
        this.props.openEditKYBTestcacheModal(this.props.kybTestcacheRecord);
    }

    handleDeleteKYBTestcacheRecord = () => {
        this.props.toggleDeleteKYBTestcacheModal(this.props.kybTestcacheRecord.id);
    }

    get kybTestcacheCheckbox() {
        return (
            <td className="low-width">
                <Checkbox
                    checked={this.props.isSelected}
                    onChange={this.handleKYBTestcacheCheckboxSelect}
                />
            </td>
        )
    }

    get kybTestcacheEditDelete() {
        return (
            <td
                className="low-width"
                onMouseEnter={() => this.setState({isHovered: true})}
                onMouseLeave={() => this.setState({isHovered: false})}
            >
                <div className={this.state.isHovered ? "edit-testcache-show" : "edit-testcache-hide"}>
                    <Icon link
                          name="pencil alternate"
                          size="large"
                          onClick={this.handleEditKYBTestcacheRecord}
                    />
                    <Icon link
                          name="trash alternate outline" color="red"
                          size="large"
                          onClick={this.handleDeleteKYBTestcacheRecord}
                    />
                </div>
            </td>
        )
    }

    get organizationName() {
        const { organizationName } = this.props;
        return (
            <td>
                {organizationName}
            </td>
        )
    }

    get businessId() {
        const { businessId } = this.props;
        return (
            <td>
                {businessId}
            </td>
        )
    }

    get businessIdType() {
        const { businessIdType } = this.props;
        return (
            <td>
                {businessIdType}
            </td>
        )
    }

    get addressLine() {
        const { addressLine1 } = this.props;
        return (
            <td>
                {addressLine1}
            </td>
        )
    }

    get locality() {
        const { locality } = this.props;
        return (
            <td>
                {locality}
            </td>
        )
    }

    get province() {
        const { province } = this.props;
        return (
            <td>
                {province}
            </td>
        )
    }

    get countryName() {
        const { countryCode } = this.props;
        let countryLabel = _.result(_.find(COUNTRIES, {
            'value': countryCode
        }), 'label');
        return (
            <td>
                {countryLabel || countryCode}
            </td>
        )
    }

    get phoneNumber() {
        const { phoneNumber } = this.props;
        return (
            <td>
                {phoneNumber}
            </td>
        )
    }

    get emailAddress() {
        const { emailAddress } = this.props;
        return (
            <td>
                {emailAddress}
            </td>
        )
    }

    get datasource() {
        const { datasource } = this.props;
        return (
            <td>
                {datasource}
            </td>
        )
    }


    render() {
        return (
            <tr>
                {this.kybTestcacheCheckbox}
                {this.kybTestcacheEditDelete}
                {this.organizationName}
                {this.businessId}
                {this.businessIdType}
                {this.addressLine}
                {this.locality}
                {this.province}
                {this.countryName}
                {this.phoneNumber}
                {this.emailAddress}
                {this.datasource}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    all_kyb_testcache_records_selected: state.support.kybTestcache.all_kyb_testcache_records_selected,
});

const mapDispatchToProps = dispatch => ({
    selectSomeKYBTestcache: (recordId, isSelected) => { dispatch(selectSomeKYBTestcache(recordId, isSelected)) },
    openEditKYBTestcacheModal: (kybTestcacheRecord) => { dispatch(openEditKYBTestcacheRecordsModal(kybTestcacheRecord)) },
    toggleDeleteKYBTestcacheModal: (kybTestcacheId) => { dispatch(toggleDeleteKYBTestcacheRecordsModal(kybTestcacheId)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYBTestCacheListRow)
